export const RECEIVE_PACKAGE_DATA = "RECEIVE_PACKAGE_DATA";
export const SHOW_LOADER = "SHOW_PACKAGE_UPGRADE_SERVICE_LOADER";

export interface IPackageUpgradeState {
    packageInformationData?: PackageInformationData;
    isLoading: boolean;
}

export interface PackageInformationData {
    PackageInformation?: PackageInformation[];
}

export interface PackageInformation {
    IsActive?: boolean;
    PackagePrice?: string;
    IsPacakgeUpgradable?: boolean;
    PackageName?: string;
    Products?: any[];
    PackageValue?: string;
    SubcriptionType?: string;
}

export interface GetPackageDataAction {
    type: "RECEIVE_PACKAGE_DATA";
    packageInformationData: PackageInformationData;
}
export interface ShowAction {
    type: "SHOW_PACKAGE_UPGRADE_SERVICE_LOADER";
    isLoading: boolean;
}

export type KnownAction = GetPackageDataAction | ShowAction;
